<template>
  <div class="form-group">
    <label
      v-bind:class="{ 'text-danger': current.errors && current.errors.proveedor }"
    >{{titulo}}</label>
    <v-select
      label="nombre"
      v-model="current.lista_precio"
      :filterable="false"
      :options="lista_precio"
      @search="onSearch"
    >
      <template slot="no-options">Listas de precio no encontrada...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">

          {{ option.id }} - {{ option.nombre }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">

          {{ option.id }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.proveedor"
      class="form-text text-danger"
    >{{ current.errors.proveedor }}</small>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
   props: {
    current: {
      type: Object,
    },
    titulo: {
      type: String,
      default: 'Lista Precio'
    },
  },
  computed: {
    ...mapGetters({
      lista_precio: "catalogos/lista_precio"
    })
  },
  mounted() {
    this.$store.dispatch("catalogos/lista_precio", {
      activo: true,
      page: 1,
      quitar_paginacion: true
    });
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/lista_precio", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search
      });
      // vm.proveedores = that.tiendas;
      loading(false);
      /*ProveedorService.fetch().then(res => {
        vm.proveedores = res.data;
        
      });*/
    }, 350)
  }
};
</script>